export const checkBit = (target: number, current?: number): boolean => {
    const bit = current || 0;
    return !!(bit & target || (bit === 0 && target === 0));
};

export const bitOperation = (
    current: number | undefined,
    target: number,
    { positive, defaultExtras }: { positive: boolean; defaultExtras: number }
) => {
    const currentExtras = (current && !isNaN(current) && +current) || defaultExtras;

    const targetExtras = positive ? currentExtras | target : currentExtras & ~target;

    return targetExtras;
};
